// src/services/postFormBackend.js

export const submitForm = async (data, slug) => {
  const url = process.env.REACT_APP_FORMBACKEND_URL;
  const code = process.env.REACT_APP_FORMBACKEND_CODE;

  if (!url) {
    console.error("Form backend URL is not defined. Make sure REACT_APP_FORMBACKEND_URL is set in your .env file.");
    throw new Error("Form submission is not configured correctly.");
  }
  if (!slug) {
    console.error("No slug was provided to the submitForm function.");
    throw new Error("Form submission is missing the required slug.");
  }

  let endpoint = `${url.replace(/\/$/, '')}/${slug}`;

  if (code) {
    endpoint += `?code=${code}`;
  }

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: response.statusText }));
      throw new Error(`Form submission failed: ${errorData.message || 'Server responded with an error'}`);
    }

    return await response.json();

  } catch (error) {
    console.error('There was an error submitting the form:', error);
    throw error;
  }
};

export const submitFormWithFiles = async (data, slug) => {
  const url = process.env.REACT_APP_FORMBACKEND_URL;
  const code = process.env.REACT_APP_FORMBACKEND_CODE;

  if (!url) throw new Error("Missing backend URL");
  if (!slug) throw new Error("Missing slug");

  let endpoint = `${url.replace(/\/$/, "")}/${slug}`;
  if (code) endpoint += `?code=${code}`;

  const formData = new FormData();

  // Separate documents from payload
  const { documentsInput, ...rest } = data;

  // Append JSON payload
  formData.append("data", JSON.stringify(rest));

  // Append files + matching documentTypes in order
  if (documentsInput && Array.isArray(documentsInput)) {
    documentsInput.forEach((doc) => {
      if (!doc.file || !doc.type) return;

      doc.file.forEach((file) => {
        // IMPORTANT: order matters, append type BEFORE file pair
        formData.append("documentTypes", doc.type);
        formData.append("documents", file);
      });
    });
  }

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Upload failed: ${text}`);
    }

    return await response.json();

  } catch (error) {
    console.error("Form upload error:", error);
    throw error;
  }
};
